// src/features/project-intake/components/WorkRequestSelector.tsx

import React from 'react';

interface WorkRequestSelectorProps {
  options: string[];
  selectedValues: string[];
  onToggle: (value: string) => void;
  error: string | null;
}

// Multi-select button group for work request types
export const WorkRequestSelector = React.memo<WorkRequestSelectorProps>(
  ({ options, selectedValues, onToggle, error }) => {
    return (
      <div>
        <label className="block text-sm font-medium theme-text-secondary mb-2">
          Select Work Request Types <span className="text-red-500 ml-1">*</span>
        </label>
        <div className="flex flex-wrap gap-2">
          {options.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(option)}
              className={`px-4 py-2 rounded-lg border text-sm font-medium transition-all ${
                selectedValues.includes(option)
                  ? 'bg-blue-600 text-white border-blue-600 shadow-md'
                  : 'theme-card theme-text-primary theme-border hover:border-blue-500 hover:bg-blue-600/10'
              } ${error ? 'border-red-500' : ''}`}
            >
              {selectedValues.includes(option) && <span className="mr-1">✓</span>}
              {option}
            </button>
          ))}
        </div>
        {error && (
          <p className="text-red-400 text-xs mt-2 flex items-center gap-1">
            <span>⚠</span> {error}
          </p>
        )}
      </div>
    );
  }
);

WorkRequestSelector.displayName = 'WorkRequestSelector';
